import React from 'react';

const HeartFilled = ({ size = 24, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      {...props}
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9798 0.183594C11.3528 0.183594 9.89663 0.975004 8.98876 2.1891C8.0809 0.975004 6.62472 0.183594 4.99775 0.183594C2.2382 0.183594 0 2.43192 0 5.21085C0 6.28105 0.170786 7.27031 0.467416 8.18763C1.88764 12.6843 6.26517 15.3733 8.43146 16.1107C8.73708 16.2186 9.24045 16.2186 9.54607 16.1107C11.7124 15.3733 16.0899 12.6843 17.5101 8.18763C17.8067 7.27031 17.9775 6.28105 17.9775 5.21085C17.9775 2.43192 15.7393 0.183594 12.9798 0.183594Z"
        fill="CurrentColor"
      />
    </svg>
  );
};

export default HeartFilled;
